import React from 'react'
import PropTypes from 'prop-types'
import { Container } from '@scentregroup/ui'
import classNames from 'classnames'
import PatternSVG from '../../assets/images/pattern.inline.svg'
import style from './index.scss'

const SectionHeading = ({ title, color }) => (
  <header className={style[color]}>
    <div
      className={classNames(style.anglePattern, {
        [style.anglePatternGrey]: color !== 'Seasonal',
      })}
      aria-hidden="true"
    >
      <PatternSVG />
    </div>
    <Container type="large" className={style.container}>
      <h1 className={style.title}>{title}</h1>
    </Container>
  </header>
)

SectionHeading.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['Grey', 'Seasonal', 'White']).isRequired,
}

export default SectionHeading
